import React, { useState } from 'react';
import {
  FiUsers, FiTruck, FiDollarSign, FiMessageSquare,
  FiHelpCircle, FiBell, FiBarChart2, FiPackage,
  FiMapPin, FiCalendar, FiCreditCard, FiSettings,
  FiShield, FiAward, FiTrendingUp, FiSearch,
  FiUpload, FiDownload, FiGlobe, FiSmartphone
} from 'react-icons/fi';

function AdminFeatures() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const features = [
    {
      id: 'users',
      category: 'gestion',
      title: 'Gestion des utilisateurs',
      description: 'Gestion complète des utilisateurs de la plateforme',
      icon: <FiUsers className="w-6 h-6" />,
      details: [
        'Inscription et authentification (clients, déménageurs, admin)',
        'Profils utilisateurs détaillés',
        'Gestion des rôles et permissions',
        'Statut de connexion en temps réel',
        'Historique des activités utilisateurs',
        'Gestion des bannissements et restrictions'
      ],
      color: 'blue'
    },
    {
      id: 'quotes',
      category: 'core',
      title: 'Système de devis',
      description: 'Génération et gestion des devis de déménagement',
      icon: <FiPackage className="w-6 h-6" />,
      details: [
        'Création de devis par les clients',
        'Diffusion aux déménageurs disponibles',
        'Réponse et négociation des prix',
        'Acceptation et confirmation de devis',
        'Suivi du statut des devis',
        'Historique complet des devis'
      ],
      color: 'yellow'
    },
    {
      id: 'moves',
      category: 'core',
      title: 'Gestion des déménagements',
      description: 'Suivi et gestion des déménagements',
      icon: <FiTruck className="w-6 h-6" />,
      details: [
        'Planification des déménagements',
        'Attribution aux déménageurs',
        'Suivi en temps réel',
        'Gestion des statuts (en attente, confirmé, en cours, terminé)',
        'Historique complet des déménagements',
        'Évaluation et notation'
      ],
      color: 'green'
    },
    {
      id: 'payments',
      category: 'finance',
      title: 'Gestion des paiements',
      description: 'Système de paiement intégré',
      icon: <FiDollarSign className="w-6 h-6" />,
      details: [
        'Intégration Stripe pour les paiements',
        'Suivi des transactions',
        'Gestion des remboursements',
        'Historique des paiements',
        'Rapports financiers',
        'Paiements sécurisés'
      ],
      color: 'green'
    },
    {
      id: 'messages',
      category: 'communication',
      title: 'Messagerie',
      description: 'Communication entre utilisateurs',
      icon: <FiMessageSquare className="w-6 h-6" />,
      details: [
        'Chat en temps réel entre clients et déménageurs',
        'Messages texte et vocaux',
        'Notifications de nouveaux messages',
        'Historique des conversations',
        'Messages privés avec l\'admin',
        'Support client intégré'
      ],
      color: 'purple'
    },
    {
      id: 'tickets',
      category: 'support',
      title: 'Système de tickets',
      description: 'Support client via tickets',
      icon: <FiHelpCircle className="w-6 h-6" />,
      details: [
        'Création de tickets de support',
        'Catégorisation (qualité, technique, paiement)',
        'Attribution aux administrateurs',
        'Suivi du statut',
        'Résolution et fermeture',
        'Historique des interactions'
      ],
      color: 'orange'
    },
    {
      id: 'notifications',
      category: 'communication',
      title: 'Notifications',
      description: 'Système de notifications multi-canaux',
      icon: <FiBell className="w-6 h-6" />,
      details: [
        'Notifications in-app',
        'Notifications push (mobiles)',
        'Notifications email',
        'Notifications SMS',
        'Préférences de notification',
        'Notifications système de l\'admin'
      ],
      color: 'red'
    },
    {
      id: 'analytics',
      category: 'gestion',
      title: 'Analyses et statistiques',
      description: 'Tableaux de bord et analyses détaillées',
      icon: <FiBarChart2 className="w-6 h-6" />,
      details: [
        'Tableau de bord administrateur',
        'Statistiques en temps réel',
        'Graphiques de conversion',
        'Analyse des performances',
        'Top déménageurs',
        'Métriques de croissance'
      ],
      color: 'indigo'
    },
    {
      id: 'reports',
      category: 'gestion',
      title: 'Rapports',
      description: 'Génération de rapports détaillés',
      icon: <FiDownload className="w-6 h-6" />,
      details: [
        'Rapports utilisateurs',
        'Rapports de déménagements',
        'Rapports financiers',
        'Rapports de tickets',
        'Rapports de conversion',
        'Export en JSON/CSV/PDF'
      ],
      color: 'teal'
    },
    {
      id: 'location',
      category: 'core',
      title: 'Géolocalisation',
      description: 'Services basés sur la localisation',
      icon: <FiMapPin className="w-6 h-6" />,
      details: [
        'Recherche de déménageurs à proximité',
        'Calcul de distances',
        'Optimisation des trajets',
        'Cartes interactives',
        'Géolocalisation en temps réel',
        'Zones de couverture'
      ],
      color: 'pink'
    },
    {
      id: 'ai',
      category: 'innovation',
      title: 'Assistant IA',
      description: 'Intelligence artificielle intégrée',
      icon: <FiSmartphone className="w-6 h-6" />,
      details: [
        'Chatbot assistant',
        'Recommandations personnalisées',
        'Analyse prédictive',
        'Traitement du langage naturel',
        'Suggestions intelligentes',
        'Base de connaissances (RAG)'
      ],
      color: 'cyan'
    },
    {
      id: 'security',
      category: 'securite',
      title: 'Sécurité',
      description: 'Système de sécurité avancé',
      icon: <FiShield className="w-6 h-6" />,
      details: [
        'Authentification JWT',
        'Hachage des mots de passe (bcrypt)',
        'Validation des données',
        'Protection CSRF',
        'Gestion des permissions',
        'Audit et logs de sécurité'
      ],
      color: 'red'
    },
    {
      id: 'subscriptions',
      category: 'finance',
      title: 'Abonnements',
      description: 'Gestion des plans d\'abonnement',
      icon: <FiTrendingUp className="w-6 h-6" />,
      details: [
        'Plans d\'abonnement pour déménageurs',
        'Gestion des essais gratuits',
        'Facturation récurrente',
        'Limites par plan',
        'Gestion des paiements d\'abonnement',
        'Historique des abonnements'
      ],
      color: 'purple'
    }
  ];

  const categories = [
    { id: 'all', name: 'Toutes les fonctionnalités' },
    { id: 'core', name: 'Fonctionnalités principales' },
    { id: 'gestion', name: 'Gestion & Administration' },
    { id: 'communication', name: 'Communication' },
    { id: 'finance', name: 'Finance & Paiements' },
    { id: 'support', name: 'Support client' },
    { id: 'securite', name: 'Sécurité' },
    { id: 'innovation', name: 'Innovation & IA' }
  ];

  const filteredFeatures = selectedCategory === 'all'
    ? features
    : features.filter(f => f.category === selectedCategory);

  const getColorClasses = (color) => {
    const colors = {
      blue: 'bg-blue-500/20 border-blue-500/30 text-blue-400',
      yellow: 'bg-yellow-500/20 border-yellow-500/30 text-yellow-400',
      green: 'bg-green-500/20 border-green-500/30 text-green-400',
      purple: 'bg-purple-500/20 border-purple-500/30 text-purple-400',
      orange: 'bg-orange-500/20 border-orange-500/30 text-orange-400',
      red: 'bg-red-500/20 border-red-500/30 text-red-400',
      indigo: 'bg-indigo-500/20 border-indigo-500/30 text-indigo-400',
      teal: 'bg-teal-500/20 border-teal-500/30 text-teal-400',
      pink: 'bg-pink-500/20 border-pink-500/30 text-pink-400',
      cyan: 'bg-cyan-500/20 border-cyan-500/30 text-cyan-400'
    };
    return colors[color] || 'bg-gray-500/20 border-gray-500/30 text-gray-400';
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-yellow-400 mb-2">Fonctionnalités de l'application</h1>
        <p className="text-gray-400">Vue d'ensemble de toutes les fonctionnalités disponibles</p>
      </div>

      {/* Filtres par catégorie */}
      <div className="flex flex-wrap gap-2">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => setSelectedCategory(category.id)}
            className={`px-4 py-2 rounded-lg border transition-all ${
              selectedCategory === category.id
                ? 'bg-yellow-600 border-yellow-500 text-gray-900 font-semibold'
                : 'bg-gray-800 border-gray-700 text-gray-300 hover:border-gray-600'
            }`}
          >
            {category.name}
          </button>
        ))}
      </div>

      {/* Liste des fonctionnalités */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredFeatures.map((feature) => (
          <div
            key={feature.id}
            className="bg-gray-800 border border-yellow-600/30 rounded-lg p-6 hover:border-yellow-500/50 transition-all"
          >
            <div className={`inline-flex p-3 rounded-lg border mb-4 ${getColorClasses(feature.color)}`}>
              {feature.icon}
            </div>
            <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
            <p className="text-gray-400 text-sm mb-4">{feature.description}</p>
            <div className="space-y-2">
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Détails:</p>
              <ul className="space-y-1">
                {feature.details.map((detail, index) => (
                  <li key={index} className="flex items-start text-sm text-gray-300">
                    <span className="text-yellow-400 mr-2">•</span>
                    <span>{detail}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      {filteredFeatures.length === 0 && (
        <div className="text-center py-12">
          <p className="text-gray-400">Aucune fonctionnalité trouvée dans cette catégorie</p>
        </div>
      )}

      {/* Statistiques */}
      <div className="bg-gray-800 border border-yellow-600/30 rounded-lg p-6">
        <h2 className="text-xl font-bold text-white mb-4">Résumé</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div>
            <p className="text-3xl font-bold text-yellow-400">{features.length}</p>
            <p className="text-gray-400 text-sm">Fonctionnalités totales</p>
          </div>
          <div>
            <p className="text-3xl font-bold text-blue-400">
              {features.filter(f => f.category === 'core').length}
            </p>
            <p className="text-gray-400 text-sm">Fonctionnalités principales</p>
          </div>
          <div>
            <p className="text-3xl font-bold text-green-400">
              {categories.length - 1}
            </p>
            <p className="text-gray-400 text-sm">Catégories</p>
          </div>
          <div>
            <p className="text-3xl font-bold text-purple-400">
              {features.reduce((sum, f) => sum + f.details.length, 0)}
            </p>
            <p className="text-gray-400 text-sm">Fonctionnalités détaillées</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminFeatures;


